export default import.meta.ROLLUP_FILE_URL_E08I0NYBSQBissyqM$dyHQ;